import React, { useState, useContext, useEffect } from 'react'
import { useHistory, Link, useLocation } from "react-router-dom";
import { Form, Button } from 'react-bootstrap';
// import { Formik } from 'formik';
// import * as yup from 'yup';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';

import api from '../../services/api';
import StoreContext from '../storage/context';
import AlertCustom from '../alertCustom/index.js'
// import BtnLoader from '../buttons/loader/index.js'

// schema validation
import * as schema from '../schemaValidation/index.js'


import './styles.css'

import logoNatura from '../../assets/logo-natura-black.svg'
import background from '../../assets/background-page-login.jpg'
import googleIcon from '../../assets/google-icon.png'


// define o botão de Google SSO
const GoogleLoginButton = () => {
    const loginRedirect = useGoogleLogin({
        flow: 'auth-code',
        ux_mode: 'redirect',
        redirect_uri: process.env.REACT_APP_GOOGLE_REDIRECT_URI,
    });

    return (
        <Button
            variant="outline-dark"
            onClick={() => loginRedirect()}
            className="w-100"
            style={{ fontWeight: '500', padding: '10px' }}
        >
            <img src={googleIcon} alt="Google logo" style={{ width: '20px', marginRight: '10px' }} />
            Entrar com Google
        </Button>
    );
};

const googleClientIdValue = process.env.REACT_APP_GOOGLE_CLIENT_ID

// define a tela de login da aplicação
const SignIn = () => {
    // restaga o token obtido no contexto StoreContext
    const { token, setToken, pk_user, setPKUser, setDisplayName, setGivenName, setRACF } = useContext(StoreContext);
    const history = useHistory();
    const location = useLocation();

    const [alert, setAlert] = useState({ header: '', message: '', type: '', options_btn: [] });
    const [showAlert, setShowAlert] = useState(false);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const dateCurrent = new Date();

    // ---- NOVA LÓGICA DE CAPTURA DO GOOGLE SSO ----
    useEffect(() => {
        // Verifica se há parâmetros na URL após o redirecionamento
        const searchParams = new URLSearchParams(location.search);
        const authCode = searchParams.get('code');

        // Se houver um código, significa que voltamos do login do Google e devemos enviar para o backend
        if (authCode) {
            setLoading(true);
            api.post('accounts/login', {
                'code': authCode
            })
                .then(response => {
                    const data = response.data;
                    setToken(data.token);
                    setPKUser(data.pk_user);

                    if (data.token) {
                        setDisplayName(data.full_name);
                        setGivenName(data.given_name);
                        setRACF(data.racf);

                        // Remove o parâmetro ?code= da URL para não reenviar se o usuário atualizar a página
                        history.replace(location.pathname);

                        history.push('/');
                    } else {
                        setMessage(data.message);
                    }
                    setLoading(false);
                })
                .catch(error => {
                    const errorMessage = error.response ? error.response.data.message : error.message;
                    setMessage(errorMessage);
                    setLoading(false);
                });
        }
    }, [location.search, history, location.pathname, setToken, setPKUser, setDisplayName, setGivenName, setRACF]);
    // ----------------------------------------------


    return (
        <div className="signup-container-first">
            {/* ALERT CUSTOM */}
            <AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

            <div className="signup-container" style={{ backgroundImage: `url(${background})` }}>

                <div className="signup-container-form">
                    <div className="signup-container-logo">
                        <img className="signup-logo" src={logoNatura} />
                    </div>

                    <div className="d-grid gap-2 mb-4" style={{ justifyContent: 'center' }}>
                        <GoogleOAuthProvider clientId={googleClientIdValue || "ERRO_GOOGLE_CLIENT_ID"}>
                            <GoogleLoginButton />
                        </GoogleOAuthProvider>
                    </div>

                    {message ? <p className='signin-alert-message'>{message}</p> : null}

                    <div className="signup-container-help">
                        <Link to="/faq" className="signup-faq">FAQ</Link>
                    </div>

                    <div className="signup-container-header">
                        <h1 className="signup-h1">D&A Hub</h1>
                        <p className="signup-p">Natura &Co © {dateCurrent.getFullYear()}</p>
                    </div>

                </div>
            </div >
        </div >
    );
}
export default SignIn;
